import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

import Icon from '@/components/base/Icon';

const TableChartPagination = ({
    pageIndex,
    changePage,
    pageOptions,
    canNextPage,
    canPreviousPage,
    nextPage,
    previousPage
}) => {
    const { t } = useTranslation('commons');
    const getVisiblePages = () => {
        const total = pageOptions.length;

        if (total < 6) {
            return pageOptions;
        } else {
            if (pageIndex % 5 >= 0 && pageIndex > 2 && pageIndex + 1 < total - 1) {
                return [pageIndex - 2, pageIndex - 1, pageIndex, pageIndex + 1, pageIndex + 2];
            } else if (pageIndex % 5 >= 0 && pageIndex > 2 && pageIndex + 1 >= total - 1) {
                return [total - 5, total - 4, total - 3, total - 2, total - 1];
            } else {
                return [0, 1, 2, 3, 4];
            }
        }
    };

    const handleChangePage = (pageNumber) => {
        changePage(pageNumber);
    };

    return (
        <div className="mt-6 flex items-center justify-center" data-testid="table-chart-pagination">
            {canPreviousPage && (
                <button className="mr-2" onClick={() => previousPage()} aria-label={t('previous')}>
                    <Icon className="text-xs text-icoGray-500" icon="chevron-left" />
                </button>
            )}
            {getVisiblePages().map((pageNumber) => (
                <button
                    className={clsx(
                        'mr-1 flex h-3.5 w-3.5 items-center justify-center text-xs',
                        pageIndex === pageNumber
                            ? 'font-GBold text-icoBlue'
                            : 'font-GSemiBold text-icoGray-500'
                    )}
                    aria-label={pageIndex === pageNumber ? t('current_page') : pageNumber + 1}
                    key={pageNumber}
                    onClick={() => handleChangePage(pageNumber)}>
                    {pageNumber + 1}
                </button>
            ))}
            {canNextPage && (
                <button className="ml-1" onClick={() => nextPage()} aria-label={t('next')}>
                    <Icon
                        className="text-xs text-icoGray-500 dark:text-icoDarkMode-wolf"
                        icon="chevron-right"
                    />
                </button>
            )}
        </div>
    );
};

TableChartPagination.propTypes = {
    pageIndex: PropTypes.number,
    changePage: PropTypes.func,
    pageOptions: PropTypes.array,
    canNextPage: PropTypes.bool,
    canPreviousPage: PropTypes.bool,
    nextPage: PropTypes.func,
    previousPage: PropTypes.func
};

export default TableChartPagination;
